import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { TipoActividad } from '../tipos-actividad/tipos-actividad.model';

@Injectable({
  providedIn: 'root'
})
export class TiposActividadService {
  url: string;
  token: string;
  endpoint = 'tiposActividad';

  constructor(private http: HttpClient) {}

  getTiposActividad(): Observable<TipoActividad[]> {
    return this.http.get<TipoActividad[]>(`${this.url}/${this.endpoint}/`, {
      params: { token: this.token }
    });
  }

  addTiposActividad(roles: TipoActividad): Observable<TipoActividad> {
    return this.http.post<TipoActividad>(`${this.url}/${this.endpoint}/`, {
      ...roles
    });
  }

  changeTiposActividad(p: TipoActividad): Observable<TipoActividad> {
    return this.http.patch<TipoActividad>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        roles: p,
        token: this.token
      }
    );
  }

  deleteTiposActividad(p: TipoActividad): Observable<TipoActividad> {
    return this.http.delete<TipoActividad>(
      `${this.url}/${this.endpoint}/${p.id}`,
      {
        params: { token: this.token }
      }
    );
  }

  getTiposActividadMock(): Observable<TipoActividad[]> {
    const salida: TipoActividad[] = [
      { id: 1, nombre: 'Almacenamiento' },
      { id: 2, nombre: 'Comercialización' },
      { id: 3, nombre: 'Criadero y/o registrante' },
      { id: 4, nombre: 'Experimentación' },
      { id: 5, nombre: 'Exportación' },
      { id: 6, nombre: 'Importación' },
      { id: 7, nombre: 'Laboratorio' },
      { id: 8, nombre: 'Procesamiento' },
      { id: 9, nombre: 'Producción' },
      { id: 10, nombre: 'Certificación' }
    ];
    return of(salida);
  }
}
